import React, { useState } from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import { OpTabs } from 'components/customAntd/DLS/OpTabs/OpTabs';
import OrganizationTab from './tabs/OrganizationTab';
import LicenseTab from './tabs/LicenseTab';
import { useTranslation } from 'react-i18next';

const Account: React.FC = () => {
    const [activeKey, setActiveKey] = useState<string>('organization');
    const { t } = useTranslation();
    const tabItems = [{
        key: 'organization',
        label: t('account.tabs.organization'),
        children: <OrganizationTab />,
    },
    {
        key: 'license',
        label: t('account.tabs.license'),
        children: <LicenseTab />,
    },
    ];

    return (
        <OpPage title={t('account.title')} tooltip={t('account.tooltip')} >
            <OpTabs activeKey={activeKey} onChange={setActiveKey} items={tabItems} />
        </OpPage>
    );
}

export default Account;